// extracted by mini-css-extract-plugin
export var filtersTaxo = "listResults-module--filters-taxo--3704c";
export var listResult = "listResults-module--list-result--231c5";
export var resultContent = "listResults-module--result-content--125b5";
export var resultItem = "listResults-module--result-item--9374b";
export var resultMore = "listResults-module--result-more--8644e";
export var resultResume = "listResults-module--result-resume--e5cf9";
export var resultTitle = "listResults-module--result-title--373c5";
export var resultType = "listResults-module--result-type--28094";
export var resultTypeIcon = "listResults-module--result-type-icon--89262";
export var resultTypeType = "listResults-module--result-type-type--126c0";
export var results = "listResults-module--results--052de";
export var resultsContainer = "listResults-module--results-container--c1c74";
export var resultsTop = "listResults-module--results-top--d3ca2";